import Cookies from 'js-cookie';

export const CONSENT_COOKIE_KEY = 'borsai_cookie_consent_v1';

function safeParse(raw) {
  try {
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getCookieConsent() {
  const raw = Cookies.get(CONSENT_COOKIE_KEY);
  const parsed = safeParse(raw);
  if (!parsed) return null;
  if (parsed.essential !== true) return null;
  return parsed;
}

export function setCookieConsent(consent) {
  try {
    // 1 year default retention for the consent record
    Cookies.set(CONSENT_COOKIE_KEY, JSON.stringify(consent), {
      expires: 365,
      // Important: allow staging over plain HTTP; only require secure when HTTPS.
      secure: window.location?.protocol === 'https:',
      // Lax avoids edge cases where Strict blocks cookie on some navigations.
      sameSite: 'lax',
      path: '/',
    });
  } catch {
    // ignore
  }
}

export function clearCookieConsent() {
  try {
    Cookies.remove(CONSENT_COOKIE_KEY, { path: '/' });
  } catch {
    // ignore
  }
}

export function hasEssentialConsent() {
  return !!getCookieConsent();
}
